import styled from 'styled-components';

import { Container, GenericP } from '../../../../common/Styles';

export const Wrapper = styled.div`
	background-color: #f5f5f5;
`;

export const TabWrapper = styled.div`
	width: ${(props) => props.$width ? props.$width : 'auto'}
	margin-right: ${(props) => props.right_M ? props.right_M : 'auto'}
`;

export const BusinessDesignContainer = styled(Container)(
	({ theme: { down, breakpoints } }) => `
		display: flex;
		padding: 142px 100px;

		> div {
			&:first-child {
				margin-right: 116px;
			}
		}
		${down(breakpoints.md)} {
			padding: 50px 16px;
			flex-direction: column-reverse;
			> div {
				&:first-child {
					margin-right: 0;
				}
			}
		}
		`
);

export const LeftTabContentHeader = styled.div`
	width: 100%;
	background: ${(props) => (props.bgColor ? props.bgColor : '')};
	border-radius: 8px;
	padding: 27px 40px;
	color: white;
`;

export const LeftTabContentSubHeader = styled.div`
	width: fit-content;
	background: linear-gradient(89.27deg, #ff7f3f 0.01%, #ff3e5e 100.01%);
	border-radius: 2px;
	padding: 2px 6px;
	font-size: 10px;
	font-weight: 700;
	color: white;
	text-transform: uppercase;
`;

export const UserList = styled.ul(
	({ theme: { down, breakpoints } }) => `
		position: relative;
		top: -10px;
		li {
			display: flex;
			align-items: baseline;
			justify-content: flex-start;
			background: white;
			padding: 24px;
			list-style-type: none;
			border-radius: 6px;
			margin-bottom: 5px;
			box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.1);
			&:last-child{
				margin-bottom: 0;
			}
		}
		${down(breakpoints.md)} {
			li {
				padding: 20px 16px 20px 24px; 
			}
		}
	`
);

export const LeftSmallBar = styled.span`
	background: linear-gradient(31.91deg, #ff7f3f 7.24%, #ff3e5e 92.76%);
	width: 4px;
	height: 12px;
	border-radius: 6px;
	margin-right: 12px;
`;

export const LiContent = styled(GenericP)`
	width: 90%
`;

export const UserChoice = styled.ul(
	({ theme: { down, breakpoints }, isMobile, translateBy }) => `
	border-left: 1px solid #e6e6e6;
	width: auto;
	${down(breakpoints.md)} {
		display: flex;
		align-items: center;
		border-left: none;
		margin-bottom 20px;
		transform: ${(isMobile && translateBy) ? `translateX(-${translateBy})` : 'none'};
		}
	}
`
);

export const UserChoiceItem = styled.li(
	({ theme: { down, breakpoints } }) => `
		padding: 16px;
		font-size: 16px;
		list-style-type: none;
		cursor: pointer;
		&.active {
			background: #ffe8e8;
			color: #f76162;
			font-weight: bold;
			border-left: 5px solid #f76162;
		}
		${down(breakpoints.md)} {
			&:last-child{
				margin-left: 10px;
			}
			font-size: 12px;
			min-width: 265px;
			width: 265px;
			padding: 10px 8px;
			&.active {
				border-left: none;
				border-bottom: 3px solid #f76162;
			}
		}
	`
);

export const ListWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
		${down(breakpoints.md)} {
			max-width: 100vw; 
			overflow-x: scroll;
			&.container {
			  -ms-overflow-style: none; /* for Internet Explorer, Edge */
				scrollbar-width: none; /* for Firefox */
				overflow-y: scroll;
			::-webkit-scrollbar {
				-webkit-appearance: none;
				display: none;
			}
		}
`
);
